import { ApiProperty } from "@nestjs/swagger";

export class BomIdsRequest {
    @ApiProperty()
    packingMaterialId: number[];
    @ApiProperty()
    vendorId: number;
    @ApiProperty()
    unitId?: number;
}